export default __webpack_public_path__ + "static/underline-17-3ff45f780d57f8f9ef65447fbe6f6fd1.svg";